var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"d-flex py-4"},[_c('div',{staticClass:"icon_menu"},[_c('v-icon',{attrs:{"size":"48"}},[_vm._v("mdi-cube-outline")])],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_menu pl-2"},[_c('h2',[_vm._v("รายการคลังสินค้า")])])
}]

export { render, staticRenderFns }